import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';

import LoadingComponent from 'components/loading-component';

import { loginRequest } from './config';

interface AuthenticationTemplateProps {
  children: React.ReactNode;
}

export const AuthenticationTemplate = (props: AuthenticationTemplateProps) => {
  const { children } = props;

  return (
    <MsalAuthenticationTemplate
      authenticationRequest={{ ...loginRequest }}
      interactionType={InteractionType.Redirect}
      errorComponent={() => <LoadingComponent />}
      loadingComponent={() => <LoadingComponent />}
    >
      {children}
    </MsalAuthenticationTemplate>
  )
}